import { BaseEntity, SingleApiResponse } from '@ianesthesie-kit/services';
import axios, { AxiosResponse } from 'axios';
import { MedicalResponse, SingleMedicalService } from './baseMedical.service';

export abstract class PatchableMedicalService<
  T extends BaseEntity
> extends SingleMedicalService<T> {
  upsert(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    item: Partial<T>,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    params: Record<string, any>
  ): Promise<MedicalResponse<T, false>> {
    throw new Error('Unsupported operation');
  }

  public patch(partial: Partial<T>): Promise<MedicalResponse<T, false>> {
    return axios
      .patch(this.url, partial)
      .then((response: AxiosResponse<SingleApiResponse<T>>) => response.data)
      .then((responseData) => ({
        data: this.transformResponseEntity(responseData.data)
      }))
      .catch((err) => {
        throw this.unwrapErrorDetails(err) || err;
      });
  }

  public clear(): Promise<MedicalResponse<T, false>> {
    return axios
      .delete(this.getUrl())
      .then((response: AxiosResponse<SingleApiResponse<T>>) => ({
        data: this.transformResponseEntity(response.data.data)
      }))
      .catch((err) => {
        throw this.unwrapErrorDetails(err) || err;
      });
  }
}
